"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = __importDefault(require("react"));
var react_quill_1 = __importDefault(require("react-quill"));
require("react-quill/dist/quill.snow.css");
require("./Editor.scss");
exports.Editor = function (props) {
    var theme = props.theme, modules = props.modules, formats = props.formats, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChange = props.onChange, value = props.value, defaultValue = props.defaultValue, placeholder = props.placeholder;
    var onContentChange = function (_content, _delta, _source, editor) {
        // eslint-disable-next-line no-console
        console.log(editor.getHTML()); // rich text
        // eslint-disable-next-line no-console
        console.log(editor.getText()); // plain text
        // eslint-disable-next-line no-console
        console.log(editor.getLength()); // number of characters
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("form", { className: "editorComponent" },
            react_1.default.createElement(react_quill_1.default, { theme: theme, modules: modules, formats: formats, onChange: onContentChange, value: value, defaultValue: defaultValue, placeholder: placeholder }))));
};
//# sourceMappingURL=Editor.js.map